import { render, staticRenderFns } from "./ExamItemBox.vue?vue&type=template&id=d12cea04&"
import script from "./ExamItemBox.vue?vue&type=script&lang=js&"
export * from "./ExamItemBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d12cea04')) {
      api.createRecord('d12cea04', component.options)
    } else {
      api.reload('d12cea04', component.options)
    }
    module.hot.accept("./ExamItemBox.vue?vue&type=template&id=d12cea04&", function () {
      api.rerender('d12cea04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/ExamItemBox.vue"
export default component.exports